<template>
  <div class="expande-horizontal column pt-0">
    <v-flex xs12>
      <div class="windows-style expande-horizontal fonte column">
        <transition name="slide-fade">
          <v-list-item class="pa-0 ma-0">
            <v-avatar
              @click="backToList"
              style="cursor: pointer;"
              size="27"
              :color="$theme.primary"
              class="mr-2"
              icon
            >
              <v-icon color="#f2f2f2">mdi-close</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ get_contato_empresa.new ? "Novo contato" : get_contato_empresa.label || get_contato_empresa.phone }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-mini">
                Telefones usados nos fluxos da empresa
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </transition>
      </div>
    </v-flex>

    <div
      style="min-height: 80vh; max-height: 80vh;"
      class="windows-style-content expande-horizontal wrap"
    >
      <v-flex xs12>
        <v-form ref="form">
          <div class="expande-horizontal wrap pt-3">
            <v-flex class="px-2" xs12 md6>
              <v-text-field
                v-model="get_contato_empresa.label"
                filled
                label="Nome do contato"
                clearable
                :color="$theme.primary"
                placeholder="ex: Entregas Polo Central"
              ></v-text-field>
            </v-flex>
            <v-flex class="px-2" xs12 md6>
              <v-text-field
                v-model="get_contato_empresa.phone"
                filled
                label="Telefone"
                clearable
                :color="$theme.primary"
                :rules="[v => !!v || 'Preencha este campo']"
                placeholder="ex: (96) 99999-9999"
              ></v-text-field>
            </v-flex>
          </div>

          <div class="expande-horizontal wrap">
            <v-flex class="px-2" xs12 md4>
              <v-select
                v-model="get_contato_empresa.purpose"
                :items="purposes"
                item-text="label"
                item-value="value"
                filled
                label="Finalidade"
                :color="$theme.primary"
                :rules="[v => !!v || 'Preencha este campo']"
              ></v-select>
            </v-flex>
            <v-flex class="px-2" xs12 md4>
              <v-autocomplete
                v-model="get_contato_empresa.unity"
                :items="get_contatos_empresa_opcoes.unities"
                item-text="nome"
                item-value="_id"
                filled
                clearable
                label="Polo"
                placeholder="Todos os polos"
                :color="$theme.primary"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="px-2" xs12 md4>
              <v-autocomplete
                v-model="get_contato_empresa.responsible_user"
                :items="get_contatos_empresa_opcoes.users"
                item-text="nome"
                item-value="_id"
                filled
                clearable
                label="Funcionario responsavel"
                placeholder="Selecione um responsavel"
                :color="$theme.primary"
              ></v-autocomplete>
            </v-flex>
          </div>

          <v-flex class="px-2" xs12>
            <v-switch
              v-model="get_contato_empresa.active"
              inset
              :color="$theme.primary"
              label="Contato ativo"
            ></v-switch>
          </v-flex>
        </v-form>
      </v-flex>
    </div>

    <div class="expande-horizontal py-1 windows-style-bottom">
      <v-btn large dark @click="valida_form" :color="$theme.primary">
        <span class="fonte">Salvar</span>
      </v-btn>
      <v-btn
        v-if="get_contato_empresa._id"
        large
        text
        color="red"
        class="ml-2"
        @click="excluir_contato_empresa(get_contato_empresa)"
      >
        Remover
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      purposes: [
        { label: "Entregas", value: "delivery" },
        { label: "Acompanhamento de vendas", value: "sale_follow_up" },
        { label: "Responsavel por orcamentos", value: "budget_owner" }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "get_contato_empresa",
      "get_contatos_empresa_opcoes"
    ])
  },
  methods: {
    ...mapActions([
      "criar_contato_empresa",
      "atualizar_contato_empresa",
      "excluir_contato_empresa",
      "listar_opcoes_contatos_empresa"
    ]),
    valida_form() {
      if (this.$refs.form.validate()) {
        this.get_contato_empresa._id
          ? this.atualizar_contato_empresa()
          : this.criar_contato_empresa();
      }
    },
    backToList() {
      this.$store.commit("set_contato_empresa", {});
      this.$forceUpdate();
    }
  },
  created() {
    if (!this.get_contatos_empresa_opcoes.unities.length && !this.get_contatos_empresa_opcoes.users.length) {
      this.listar_opcoes_contatos_empresa();
    }
  }
};
</script>
